export default __webpack_public_path__ + "static/media/radio.8cd354fa.svg";